import React from "react";

import { useTypedSelector } from "../../hooks.tsx";
import PromptPanel from "./PromptPanel.tsx";
import ResponsePrompt from "./ResponsePrompt.tsx";
import { getSelectedConversationExchanges } from "../../store/conversation.tsx";

interface ExchangeProps {
  exchangeId: string;
}

const ExchangePanel: React.FC<ExchangeProps> = ({ exchangeId }) => {
  const exchange = useTypedSelector(
    (state) => getSelectedConversationExchanges(state)?.byId[exchangeId],
  );

  if (!exchange) return null;

  return (
    <React.Fragment key={exchange.id}>
      {exchange.prompt && exchange.prompt.trim() !== "" && (
        <PromptPanel
          key={`user_${exchange.id}`}
          role="user"
          content={exchange.prompt}
          exchange_id={exchange.id}
        ></PromptPanel>
      )}
      <ResponsePrompt exchange={exchange} />
    </React.Fragment>
  );
};

export default React.memo(ExchangePanel);
